export default __webpack_public_path__ + "static/media/data_center_security.e282db41.png";